import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { KModal, KModalSize, KModalVariant } from "./KModal";
import { animateInfoButton, tooltipate } from "../index";
import { HelpModalIcon } from "./commons";
import { animated, useSpring } from "@react-spring/web";
import { Translate } from "react-redux-i18n";
export const KContainer = ({ onTooSmall, screenMinWidth, id, helpModal, className, children, fluid, marginBottom = 60, marginTop = 60, paddingBottom, paddingTop }) => {
    const key = `UIKIT_CONTAINER_${id || "default"}_${window.location.pathname}_SHOWED`;
    const wasFirstTime = localStorage.getItem(key) !== "true";
    const [show, setShow] = useState(wasFirstTime);
    const [springs, api] = useSpring(() => ({
        from: { opacity: 1, scale: 1, color: "#8c9ab1", transformOrigin: "center center" },
    }));
    const [otherClasses, setOtherClasses] = useState("");
    function closeEvent(dontPropagate = false) {
        setShow(false);
        if (helpModal && helpModal.onShow && !dontPropagate) {
            helpModal.onShow(false);
        }
        if (wasFirstTime && helpModal) {
            localStorage.setItem(key, "true");
            animateInfoButton(api);
        }
    }
    useEffect(() => {
        if ((helpModal === null || helpModal === void 0 ? void 0 : helpModal.show) === false) {
            closeEvent(true);
        }
    }, [helpModal === null || helpModal === void 0 ? void 0 : helpModal.show]);
    useEffect(() => {
        const updateWindowDimensions = () => {
            if (screenMinWidth && window.innerWidth < screenMinWidth) {
                setOtherClasses("too-small");
                if (onTooSmall) {
                    onTooSmall(true);
                }
            }
            else {
                setOtherClasses("");
                if (onTooSmall) {
                    onTooSmall(false);
                }
            }
        };
        window.addEventListener("resize", updateWindowDimensions);
        updateWindowDimensions();
        return () => window.removeEventListener("resize", updateWindowDimensions);
    }, [screenMinWidth]);
    return (_jsxs(_Fragment, { children: [_jsxs(Container, { fluid: fluid, style: { marginBottom, marginTop, paddingBottom, paddingTop }, className: `${className} ${otherClasses ? `${otherClasses} blur` : ""}`, children: [helpModal && !show
                        ? tooltipate(_jsx(animated.i, { className: `helper-btn fa-2x ${helpModal.icon ? helpModal.icon : HelpModalIcon.HELP}`, style: { ...springs }, onClick: () => {
                                setShow(true);
                                if (helpModal.onShow) {
                                    helpModal.onShow(true);
                                }
                            } }), helpModal.tooltip, "left")
                        : null, children, helpModal ? (_jsx(KModal, { show: helpModal.show === undefined ? show : helpModal.show, variant: helpModal.variant || KModalVariant.transparent, header: helpModal.header || _jsx(_Fragment, { children: "\u00A0" }), size: helpModal.size || KModalSize.xl, onHide: () => closeEvent(), footer: _jsx("div", {}), centered: helpModal.verticallyCentered, children: helpModal.content })) : null] }), _jsx("div", { className: `too-small-warning ${otherClasses}`, children: _jsxs("div", { className: "content", children: [_jsxs("div", { className: "icon", children: [_jsx("i", { className: "browser fal fa-browser" }), _jsx("i", { className: "arrows fal fa-arrow-up-right-and-arrow-down-left-from-center" })] }), _jsx(Translate, { className: "title", value: "generic.tooSmall.title" }), _jsx("br", {}), _jsx(Translate, { className: "description", value: "generic.tooSmall.description" })] }) })] }));
};
